import { formatarPercentual } from '@/utils/percentual.utils'

export class CalculadoraDePercentual {
  private readonly total: number

  constructor(
    valores: number[],
    private readonly locale = 'pt-BR',
  ) {
    this.total = valores.reduce((acc, valor) => acc + valor, 0)
  }

  calcularPercentual(valor: number): number {
    if (this.total === 0) return 0
    return (valor / this.total) * 100
  }

  calcularPercentualFormatado(valor: number): string {
    return this.formatarPercentual(this.calcularPercentual(valor))
  }

  formatarPercentual(valor: number): string {
    return formatarPercentual(valor, this.locale)
  }
}
